<template>
  <div class="">
    <div class="card m-1" v-for="initiative in initiatives" :key="initiative.name">
      <div class="card-body maadi-dark-card d-flex">
        <div class="d-flex align-items-center m-1" style="font-size: 2.0em; font-weight: 500">
          {{ initiative.name }}
        </div>
        <div class="d-flex">
          <div class="p-2 m-1" style="border: solid #3E597A 1px; width: 150px" v-for="value in initiative.values" :key="value.type">
            <div class="text-center" style="font-size: 2.0em; font-weight: 500">
              {{ value.value }}
            </div>
            <div class="text-center" style="font-size: 1.0em; text-transform: uppercase">
              {{ value.type }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['initiatives']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/activities/InitiativeDashboard.vue